export default __webpack_public_path__ + "static/media/profilePic.f9b727f8.png";